var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import updateModelFromJson from "../../Models/Definition/updateModelFromJson";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
const cartoScratch = new Cartographic();
let LatLonHeightTraits = (_dec = primitiveTrait({
  type: "number",
  name: "Latitude",
  description: "Latitude in degrees"
}), _dec2 = primitiveTrait({
  type: "number",
  name: "Longitude",
  description: "Longitude in degrees"
}), _dec3 = primitiveTrait({
  type: "number",
  name: "Height",
  description: "Height above ellipsoid in metres"
}), _class = class LatLonHeightTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "latitude", _descriptor, this);
    _initializerDefineProperty(this, "longitude", _descriptor2, this);
    _initializerDefineProperty(this, "height", _descriptor3, this);
  }
  static setFromCartesian(model, stratumName, position) {
    const cartographic = Cartographic.fromCartesian(position, undefined, cartoScratch);
    const latitude = CesiumMath.toDegrees(cartographic.latitude);
    const longitude = CesiumMath.toDegrees(cartographic.longitude);
    const height = cartographic.height;
    return updateModelFromJson(model, stratumName, {
      latitude,
      longitude,
      height
    });
  }
  static toCartographic(model, result) {
    const {
      longitude,
      latitude,
      height
    } = model;
    if (longitude === undefined || latitude === undefined || height === undefined) {
      return undefined;
    }
    return Cartographic.fromDegrees(longitude, latitude, height, result !== null && result !== void 0 ? result : new Cartographic());
  }
  static toCartesian(model, result) {
    const {
      longitude,
      latitude,
      height
    } = model;
    if (longitude === undefined || latitude === undefined || height === undefined) {
      return;
    }
    return Cartesian3.fromDegrees(longitude, latitude, height, undefined, result !== null && result !== void 0 ? result : new Cartesian3());
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "latitude", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "longitude", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "height", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { LatLonHeightTraits as default };